import React from 'react';
import { colors, spacing, radius } from '../../styles/tokens';

interface CardProps {
  children: React.ReactNode;
  /** Extra inline styles merged onto the card container. */
  style?: React.CSSProperties;
  /** Optional padding override (default: spacing.lg / 16px). */
  padding?: string | number;
  className?: string;
}

/**
 * Standard card container — dark panel with border.
 * Replaces the repeated `{ background:'#10151b', padding:16, borderRadius:8, border:'1px solid #2a3540' }` pattern.
 */
export function Card({ children, style, padding, className }: CardProps) {
  return (
    <div
      className={className}
      style={{
        backgroundColor: colors.bg.secondary,
        padding: padding ?? spacing.lg,
        borderRadius: radius.lg,
        border: `1px solid ${colors.border.default}`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
